import { createSlice } from '@reduxjs/toolkit';

import chto_takoe_erir from './articles/chto_takoe_erir';
import chto_takoe_operator_reklamnih_dannih from './articles/chto_takoe_operator_reklamnih_dannih';
import markirovka_reklami_v_internete from './articles/markirovka_reklami_v_internete';
import markirovka_reklami_v_telegram from './articles/markirovka_reklami_v_telegram';
import otvetstvennost_za_shtrafi from './articles/otvetstvennost_za_shtrafi';
import poryadok_razmeshenia_markera_v_reklame from './articles/poryadok_razmeshenia_markera_v_reklame';
import { IBlogSlice } from './types';

const initialState: IBlogSlice = {
  articles: {
    markirovka_reklami_v_internete,
    markirovka_reklami_v_telegram,
    poryadok_razmeshenia_markera_v_reklame,
    chto_takoe_operator_reklamnih_dannih,
    chto_takoe_erir,
    otvetstvennost_za_shtrafi,
  },
};

const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {},
});

export default blogSlice;
